import './styles.scss';

export interface SelectAllProps {
  onClick: () => void;
  children: string | JSX.Element;
}

export const SelectAll = ({ onClick, children }: SelectAllProps): JSX.Element => (
  <button className="clearButton" onClick={onClick}>
    {children}
  </button>
);
